module.exports = __webpack_public_path__ + "static/media/error-red.09ebb5e8.svg";